import { Box, Divider, Tab, Tabs, styled } from '@mui/material';
import theme from '../../../theme';
import BrandDetail from './BrandDetail';

interface BrandDetailsTabsProps {
  brand: any;
  selectedTab: number;
  onTabChange: (value: number) => void;
}

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '16px',
    color: 'text.secondary',
    minWidth: '83px',
    height: '37px',
    padding: '8px 16px',
    marginRight: '10px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.Mui-selected': {
      color: theme.palette.custom.textBlue,
      fontWeight: 500,
      backgroundColor: '#E7F0FF',
    },
  },
});

const BrandDetailsTabs = ({
  brand,
  selectedTab,
  onTabChange,
}: BrandDetailsTabsProps) => {
  const handleChange = (newValue: number) => {
    onTabChange(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: '8px',
        border: '1px solid #DCE0E7',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          '& .MuiTabs-root': {
            minHeight: 'unset',
          },
        }}
      >
        <StyledTabs
          value={selectedTab}
          onChange={(_event, newValue) => handleChange(newValue)}
        >
          <Tab label="Details" />
        </StyledTabs>
      </Box>
      <Divider />
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          '&::-webkit-scrollbar': { display: 'none' },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        {selectedTab === 0 && <BrandDetail brand={brand} />}
      </Box>
    </Box>
  );
};

export default BrandDetailsTabs;
